<template>
  <div class="order-detail-contain">
    <el-tabs v-model="activeName">
      <el-tab-pane label="待发货" name="first">
        <deliveryWait></deliveryWait>
      </el-tab-pane>
      <el-tab-pane label="已发货" name="second">
        <deliveryList></deliveryList>
      </el-tab-pane>
      <el-tab-pane label="已完成" name="four">
        <deliverySuccess></deliverySuccess>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { ref } from "vue";
import deliveryWait from "./Wait/index.vue";
import deliveryList from "./List/index.vue";
import deliverySuccess from "./Success/index.vue";
export default {
  name: "delivery",
  components: {
    deliveryWait,
    deliveryList,
    deliverySuccess,
  },
  setup() {
    const activeName = ref("first");
    return {
      activeName,
    };
  },
};
</script>
<style scoped lang="scss">
.order-detail-contain {
  height: 100%;
  padding: 20px 0;
  .el-tabs {
    height: 100%;
    :deep .el-tabs__content {
      height: calc(100% - 100px);
    }
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
